module.exports = __webpack_public_path__ + "static/media/splash.bf3dc39f.png";